module.exports = __webpack_public_path__ + "media/svgs/TAFA20-Webseite_Pfeil-unten_red-1f2cfe9a41ed71f6dc215105d26badf5.svg";